module.exports = __webpack_public_path__ + "img/IMG_1645_BlackMatted.0867518a.jpg";